/**
 * Display classification of a card. Not a stored type: the same card becomes an event or a task
 * as its dates change.
 *
 * - EVENT: an explicit START and END (the period may be timed or date-only);
 * - TASK: only a deadline (END) or no date at all.
 *
 * Calendar and Timeline both go through this rule, never through their own conditions.
 */
import type { Card } from './types';

export type CardKind = 'event' | 'task';

export function classifyCard(card: Pick<Card, 'deadline'>): CardKind {
  return card.deadline !== null && card.deadline.start_date !== null ? 'event' : 'task';
}

export function isEvent(card: Pick<Card, 'deadline'>): boolean {
  return classifyCard(card) === 'event';
}

/** A task without any date (listed in the "No date" sections). */
export function isUndated(card: Pick<Card, 'deadline'>): boolean {
  return card.deadline === null;
}
